import React, { Component, createRef, Fragment } from 'react';
import PropTypes from 'prop-types';

import superagent from 'superagent';
import cookie from 'react-cookie';
import Helmet from 'react-helmet';
import LoadingBar from 'react-top-loading-bar';
import smoothscroll from 'smoothscroll-polyfill';
import {
  isLoaded as isAuthLoaded,
  load as loadAuth,
  updateTour,
  update as updateUser,
  loadOwnBriefs,
} from 'redux/modules/auth';
import {
  loadIntros,
  loadUnreadMessages,
  updateNewMessage,
  sendMessage,
  loadMessages,
  isIntro,
  deleteMessage,
} from 'redux/modules/messages';
import { loadPendingRatings, rate } from 'redux/modules/rating';
import {
  add as addToBanner,
  remove as removeBanner,
} from 'redux/modules/banner';
import { loadBriefsWithState } from 'redux/modules/briefs';
import { resetErrorMessage } from 'redux/modules/errorMessage';
import {
  resetSuccessMessage,
  setSuccessMessage,
} from 'redux/modules/successMessage';
import { resetHighlightElement } from 'redux/modules/highlightElement';
import {
  loadCount as loadNotificationCount,
  startedLoadingOldCount,
  finishedLoadingOldCount,
} from 'redux/modules/notifications';
import { acceptPitch, declinePitch } from 'redux/modules/briefDetails';
import { flashHighlight } from 'helpers/HelperFunctions';
import { push } from 'connected-react-router';
import { asyncConnect } from 'redux-connect';
import Banner from 'components/Banners/Banner/Banner';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import RatingModal from 'components/Rating/RatingModal';
import MainHeader from 'components/Header/Main/MainHeader';
import StickyNavBar from 'components/Header/StickyNavBar/StickyNavBar';
import DynamicFooter from 'components/Footer/DynamicFooter';
import SmallFooter from 'components/Footer/SmallFooter';
import DesignSkills from 'components/Footer/Skills/DesignSkills';
import AISkills from 'components/Footer/Skills/AISkills';
import AppWebDevelopmentSkills from 'components/Footer/Skills/AppWebDevelopmentSkills';
import BusinessStartupSkills from 'components/Footer/Skills/BusinessStartupSkills';
import MarketingSkills from 'components/Footer/Skills/MarketingSkills';
import MusicAudioSkills from 'components/Footer/Skills/MusicAudioSkills';
import VideoAnimationSkills from 'components/Footer/Skills/VideoAnimationSkills';
import DefaultSkills from 'components/Footer/Skills/DefaultSkills';
import Alert from 'react-s-alert';
import { renderRoutes } from 'react-router-config';
import { setupTagManager, setTrackingIdentity } from 'helpers/Analytics';
// import DevTools from 'containers/DevTools/DevTools';
import favicon from 'static/favicon.ico';
import config from '../../config';
import styles from './App.module.scss';
import '../../theme/bootstrap.overrides.scss';
import AlertHandler from '../../components/AlertHandler/AlertHandler';
import PricingPromotionBanner from 'components/Banners/PricingPromotionBanner/PricingPromotionBanner';
import CelloReferralBoot from 'components/CelloReferral/CelloReferralBoot';
import { isBlackFridayActive } from 'helpers/BlackFridayHelper';
// import {
//   isLinkedInUser,
//   getLinkedInPromoMessage,
//   isLinkedInPromoActive,
// } from 'helpers/LinkedInPromoHelper';

@asyncConnect(
  [
    {
      promise: ({ store: { dispatch, getState } }) => {
        const promises = [];

        if (!isAuthLoaded(getState())) {
          promises.push(dispatch(loadAuth()));
        }

        return Promise.all(promises);
      },
    },
  ],
  (state) => ({
    user: state.auth.user,
    authError: state.auth.authError,
    error: state.errorMessage,
    successMessage: state.successMessage,
    highlightElement: state.highlightElement,
    messages: state.messages.messages,
    introsLeft: state.messages.introsLeft,
    introsLoading: state.messages.introsLoading,
    count: state.notifications.count,
    oldCount: state.notifications.oldCount,
    loadedCount: state.notifications.loadedCount,
    loadingCount: state.notifications.loadingCount,
    loadedOldCount: state.notifications.loadedOldCount,
    unreadMessages: state.messages.unreadMessages,
    pendingRatings: state.rating.pendingRatings,
    messageEntities: state.entities.messages,
    threadEntities: state.entities.threads,
    userEntities: state.entities.users,
    briefEntities: state.entities.briefs,
    isAsyncDataLoaded: state.reduxAsyncConnect.loaded,
    loadingBriefsWithState: state.briefs.loadingBriefsWithState,
    briefsWithState: state.briefs.briefsWithState,
    updatingUser: state.auth.updating,
  }),
  {
    pushState: push,
    resetErrorMessage,
    resetSuccessMessage,
    setSuccessMessage,
    loadIntros,
    loadNotificationCount,
    startedLoadingOldCount,
    finishedLoadingOldCount,
    updateNewMessage,
    sendMessage,
    loadMessages,
    isIntro,
    loadUnreadMessages,
    acceptPitch,
    declinePitch,
    deleteMessage,
    loadPendingRatings,
    addToBanner,
    removeBanner,
    rate,
    updateTour,
    updateUser,
    resetHighlightElement,
    loadBriefsWithState,
    loadOwnBriefs,
  }
)
class App extends Component {
  static checkUtmCampaigns(utmCampaign) {
    // The following utm_campaigns mean we believe
    // they are a buyer owning this brief and not logged in
    const campaigns = ['content-type'];

    let exists = false;
    if (Array.isArray(utmCampaign)) {
      exists = utmCampaign.some((campaign) => campaigns.indexOf(campaign) > -1);
    } else {
      exists = campaigns.indexOf(utmCampaign) > -1;
    }

    return exists;
  }

  static propTypes = {
    // children: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    location: PropTypes.object,
    user: PropTypes.object,
    authError: PropTypes.object,
    pushState: PropTypes.func.isRequired,
    resetErrorMessage: PropTypes.func,
    setSuccessMessage: PropTypes.func,
    error: PropTypes.string,
    successMessage: PropTypes.string,
    highlightElement: PropTypes.string,
    loadNotificationCount: PropTypes.func,
    count: PropTypes.number,
    loadIntros: PropTypes.func,
    loadedCount: PropTypes.bool,
    loadingCount: PropTypes.bool,
    startedLoadingOldCount: PropTypes.func,
    finishedLoadingOldCount: PropTypes.func,
    oldCount: PropTypes.number,
    loadedOldCount: PropTypes.bool,
    messages: PropTypes.object,
    updateNewMessage: PropTypes.func,
    sendMessage: PropTypes.func,
    introsLeft: PropTypes.number,
    introsLoading: PropTypes.bool,
    loadMessages: PropTypes.func,
    isIntro: PropTypes.func,
    unreadMessages: PropTypes.number,
    pendingRatings: PropTypes.array,
    loadUnreadMessages: PropTypes.func,
    acceptPitch: PropTypes.func,
    declinePitch: PropTypes.func,
    threadEntities: PropTypes.object,
    messageEntities: PropTypes.object,
    userEntities: PropTypes.object,
    deleteMessage: PropTypes.func,
    briefEntities: PropTypes.object,
    loadPendingRatings: PropTypes.func,
    loadOwnBriefs: PropTypes.func,
    addToBanner: PropTypes.func,
    removeBanner: PropTypes.func,
    rate: PropTypes.func,
    updateTour: PropTypes.func,
    updateUser: PropTypes.func,
    resetSuccessMessage: PropTypes.func,
    resetHighlightElement: PropTypes.func,
    isAsyncDataLoaded: PropTypes.bool,
    loadBriefsWithState: PropTypes.func,
    loadingBriefsWithState: PropTypes.bool,
    briefsWithState: PropTypes.array,
    updatingUser: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.loadingRef = createRef(null);
    this.state = {
      showApproveFilesPrompt: false,
      showOnboardingBanner: false,
      showResendEmailBanner: false,
      showPricingBanner: false,
      pricingBannerMessage: '',
      pricingBannerColor: '',
      isProgressShown: false,
    };
  }

  componentDidMount() {
    // polyfill for safari
    smoothscroll.polyfill();

    const {
      location: { pathname, query },
      user,
      addToBanner,
      loadIntros,
      loadUnreadMessages,
      loadNotificationCount,
      loadPendingRatings,
      loadOwnBriefs,
      loadBriefsWithState,
      finishedLoadingOldCount,
      updatingUser,
    } = this.props;

    // Set up Google Tag Manager
    if (__CLIENT__) {
      // Needs to be set before setting up Google Tag Manager (for Google Analytics)
      setupTagManager();
    }

    if (user) {
      setTrackingIdentity(user);
      loadIntros();
      loadUnreadMessages();
      loadNotificationCount();
      loadPendingRatings(user);
      loadOwnBriefs(user.id);

      if (
        typeof cookie.load('seen-approve-files-prompt') === 'undefined' &&
        !pathname.includes('/projects/b')
      ) {
        loadBriefsWithState(user.id, 1, ['paid_final_files_uploaded']);
      }

      if (__CLIENT__) {
        cookie.save('loggedIn', '1', { path: '/' });
      }

      const baseUrl =
        typeof process.env.ENDPOINT_FRONTEND !== 'undefined'
          ? `https://${process.env.ENDPOINT_FRONTEND}`
          : 'http://local.twine.net';

      superagent
        .get(`${baseUrl}/ajax_session.php?action=get_notifications_count`)
        .withCredentials()
        .set('X-Requested-With', 'XMLHttpRequest')
        .set('Accept', 'application/json')
        .end((err, res) => finishedLoadingOldCount(res.body.count));
    }

    // Crisp
    if (process.env.ENDPOINT_FRONTEND === 'www.twine.net') {
      if (typeof window !== 'undefined') {
        /* eslint-disable */
        window.$crisp = [];
        window.CRISP_WEBSITE_ID = 'ff9c90ab-bd2c-41f5-8f13-dfcb7733d282';

        // Note this is modified to not run onload with standard Crisp script, so we can wrap in timeout
        setTimeout(() => {
          (function () {
            var d = document;
            var s = d.createElement('script');

            s.src = 'https://client.crisp.chat/l.js';
            s.async = 1;
            d.getElementsByTagName('head')[0].appendChild(s);
          })();
          /* eslint-enable */
        }, 4000);

        // Set Crisp user data after script loads
        setTimeout(() => {
          if (typeof window !== 'undefined' && window.$crisp) {
            // Get UTM parameters from URL
            const getUrlVars = () => {
              const vars = {};
              const parts = window.location.href.replace(
                /[?&]+([^=&]+)=([^&]*)/gi,
                (m, key, value) => {
                  vars[key] = value;
                }
              );
              return vars;
            };

            const urlVars = getUrlVars();
            const crispKeys = [];

            // Add UTM parameters to Crisp data
            [
              'utm_source',
              'utm_medium',
              'utm_campaign',
              'utm_term',
              'utm_content',
            ].forEach((source) => {
              if (urlVars[source]) {
                crispKeys.push([source, urlVars[source]]);
              }
            });

            // Set UTM data if available
            if (crispKeys.length > 0) {
              window.$crisp.push(['set', 'session:data', [crispKeys]]);
            }

            // Set user data if user is logged in
            if (user) {
              // Set user email
              window.$crisp.push(['set', 'user:email', user.email]);

              // Determine user plan
              let plan = 'free';
              if (user.pro) {
                plan = 'pro';
              } else if (user.premium) {
                plan = 'premium';
              }

              // Set user session data
              const userSessionData = [
                ['plan', plan],
                ['twine_username', user.username],
                ['twine_user_id', user.id.toString()],
              ];

              window.$crisp.push(['set', 'session:data', [userSessionData]]);
            }
          }
        }, 5000);
      }
    }

    if (__CLIENT__) {
      if (query.utm_source) {
        cookie.save('utm_source', query.utm_source, { path: '/' });
      }

      if (query.utm_medium) {
        cookie.save('utm_medium', query.utm_medium, { path: '/' });
      }

      if (query.utm_campaign) {
        cookie.save('utm_campaign', query.utm_campaign, { path: '/' });
      }

      if (query.utm_term) {
        cookie.save('utm_term', query.utm_term, { path: '/' });
      }

      if (query.utm_content) {
        cookie.save('utm_content', query.utm_content, { path: '/' });
      }

      if (query.gclid) {
        cookie.save('utm_source', 'google', { path: '/' });
        cookie.save('utm_medium', 'cpc', { path: '/' });
        cookie.save('gclid', query.gclid, { path: '/' });
      }

      if (query.fbclid) {
        cookie.save('fbclid', query.fbclid, { path: '/' });
      }
    }

    if (__CLIENT__ && user && user.email_new !== '' && !updatingUser) {
      setTimeout(() => {
        addToBanner('email_confirmation', user.email_new, 'primary', false, 10);
      }, 1500);
    }

    const storedSuccessMessage = localStorage.getItem('successMessage');

    if (storedSuccessMessage) {
      this.props.setSuccessMessage(storedSuccessMessage);
      localStorage.removeItem('successMessage');
    }

    // Check if pricing banner should be shown on mount
    if (
      __CLIENT__ &&
      !this.state.showPricingBanner &&
      this.shouldShowPricingBanner()
    ) {
      this.showPricingBanner();
    }

    // Check if pricing banner should be hidden on mount
    if (
      __CLIENT__ &&
      this.state.showPricingBanner &&
      !this.shouldShowPricingBanner()
    ) {
      this.hidePricingBanner();
    }
  }

  componentDidUpdate(prevProps) {
    const { showResendEmailBanner, showOnboardingBanner, showPricingBanner } =
      this.state;

    const {
      user,
      highlightElement,
      resetHighlightElement,
      loadingBriefsWithState,
      briefsWithState,
    } = this.props;

    if (this.shouldShowPricingBanner() && !showPricingBanner) {
      this.showPricingBanner();
    }

    if (user && this.shouldShowOnboardingBanner() && !showOnboardingBanner) {
      this.showOnboardingBanner();
    }

    if (user && this.shouldShowResendEmailBanner() && !showResendEmailBanner) {
      this.showResendEmailBanner();
    }

    if (
      typeof window !== 'undefined' &&
      prevProps.highlightElement !== highlightElement &&
      highlightElement &&
      highlightElement !== ''
    ) {
      flashHighlight(highlightElement);
      setTimeout(() => {
        resetHighlightElement();
      }, 1000);
    }

    if (
      prevProps.loadingBriefsWithState &&
      !loadingBriefsWithState &&
      briefsWithState.length > 0
    ) {
      setTimeout(() => {
        this.showApproveFilesPrompt();
      }, 2000);
    }

    if (showPricingBanner && !this.shouldShowPricingBanner()) {
      this.hidePricingBanner();
    }

    if (user && showOnboardingBanner && !this.shouldShowOnboardingBanner()) {
      this.hideOnboardingBanner();
    }

    if (
      user &&
      showResendEmailBanner &&
      (!this.shouldShowResendEmailBanner() || user.email_verified)
    ) {
      this.hideResendEmailBanner();
    }
  }

  shouldShowOnboardingBanner = () =>
    !/(onboarding|post|message|howitworks|whyusetwine|find|get|activate|pricing|ats)/.test(
      this.props.location.pathname
    );

  shouldShowPricingBanner = () =>
    /(pricing|jobs|projects)/.test(this.props.location.pathname);

  shouldShowResendEmailBanner = () =>
    !/(onboarding|post|message|howitworks|whyusetwine|find|get|activate|pricing)/.test(
      this.props.location.pathname
    );

  showPricingBanner = () => {
    const { user } = this.props;

    // Basic eligibility checks for logged-in users
    if (user && (user.type === 'buyer' || user.pro)) {
      return;
    }

    if (!this.shouldShowPricingBanner()) {
      return;
    }

    // const isLinkedIn = isLinkedInUser();
    // A/B test variant: A = user_id % 2 === 0, B = user_id % 2 === 1
    // const isVariantA = user && user.id % 2 === 0;

    let message = '';
    let color = '';

    // Banner rules (priority top→bottom):
    // 1. LinkedIn Variant A (logged in): show current LinkedIn promo code (takes priority over Black Friday)
    // DISABLED: LinkedIn promo code banner
    // if (user && isLinkedIn && isVariantA && isLinkedInPromoActive()) {
    //   message = getLinkedInPromoMessage();
    //   color = 'primary';
    // }
    // 2. Black Friday: show to non-LinkedIn sellers, LinkedIn Variant B, AND non-logged-in users
    if (isBlackFridayActive()) {
      message = '⚡️ Black Friday Special: Up to 55% off Twine subscriptions';
      color = 'purple';
    }
    // 3. Otherwise: no banner
    else {
      return;
    }

    this.setState({
      showPricingBanner: true,
      pricingBannerMessage: message,
      pricingBannerColor: color,
      pricingBannerLink: '/pricing/creative',
    });
  };

  hidePricingBanner = () => {
    this.setState({
      showPricingBanner: false,
      pricingBannerMessage: '',
      pricingBannerColor: '',
    });
  };

  showOnboardingBanner = () => {
    const { user } = this.props;

    if (!user || (user && user.type === 'buyer')) {
      return;
    }

    if (!this.shouldShowOnboardingBanner()) {
      return;
    }

    if (
      user.avatars.placeholder ||
      user.displayname === user.username ||
      user.location.method !== 'html5' ||
      user.featured_roles.length === 0 ||
      user.skills.length === 0 ||
      user.tools.length === 0 ||
      user.covers.placeholder ||
      user.stats.num_of_testimonials === 0 ||
      user.stats.num_of_credits === 0 ||
      !user.verified ||
      user.bio.length === 0 ||
      user.sectors.length === 0
    ) {
      this.props.addToBanner('onboarding', '', 'primary', false);
      this.setState({ showOnboardingBanner: true });
    }
  };

  hideOnboardingBanner = () => {
    this.setState({ showOnboardingBanner: false }, () => {
      setTimeout(() => {
        this.props.removeBanner('onboarding');
      }, 200);
    });
  };

  showResendEmailBanner = () => {
    const { user } = this.props;

    if (!user) {
      return;
    }

    if (!this.shouldShowResendEmailBanner()) {
      return;
    }

    if (!user.email_verified && user.email_new === '') {
      this.props.addToBanner(
        'email_not_verified',
        user.email,
        'warning',
        false,
        30
      );
      this.setState({ showResendEmailBanner: true });
    }
  };

  hideResendEmailBanner = () => {
    this.setState({ showResendEmailBanner: false }, () => {
      setTimeout(() => {
        this.props.removeBanner('email_not_verified');
      }, 200);
    });
  };

  showApproveFilesPrompt = () => {
    if (typeof cookie.load('seen-approve-files-prompt') === 'undefined') {
      this.setState({
        showApproveFilesPrompt: true,
      });

      cookie.save('seen-approve-files-prompt', 1);
    }
  };

  hideApproveFilesPrompt = () => {
    this.setState({
      showApproveFilesPrompt: false,
    });

    if (typeof cookie.load('seen-approve-files-prompt') === 'undefined') {
      cookie.save('seen-approve-files-prompt', 1);
    }
  };

  handleDeleteMessage = (user, messageId) => {
    const { threadEntities, messages, deleteMessage } = this.props;
    // if it's the last message in a thread
    if (threadEntities[user.id].message === messageId) {
      const nextMessageId =
        messages[user.username].messages.length > 1
          ? messages[user.username].messages[1]
          : null;
      threadEntities[user.id].message = nextMessageId;
    }

    // actually delete
    deleteMessage(user.username, messageId);
  };

  handleRating = (userId, briefId, value, comment = '') =>
    this.props.rate(userId, briefId, value, comment);

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.isAsyncDataLoaded && !this.state.isProgressShown) {
      this.setState({ isProgressShown: true });
      // Progress.show();
      this.loadingRef.current.continuousStart();
    }

    if (nextProps.isAsyncDataLoaded && this.state.isProgressShown) {
      this.setState({ isProgressShown: false });
      // Progress.hide();
      this.loadingRef.current.complete();
    }

    if (
      nextProps.user &&
      nextProps.user.email_new !== '' &&
      !nextProps.updatingUser &&
      this.props.updatingUser
    ) {
      setTimeout(() => {
        this.props.addToBanner(
          'email_confirmation',
          nextProps.user.email_new,
          'primary',
          false,
          10
        );
      }, 50);
    }
  }

  isProject = () =>
    this.props.location.pathname === '/' ||
    /(projects)/.test(this.props.location.pathname);

  isJobs = () =>
    this.props.location.pathname === '/' ||
    /(jobs)/.test(this.props.location.pathname);

  getFooterSkillsSection = (type, category) => {
    switch (category) {
      case 'Graphic Design':
        return <DesignSkills type={type} />;
      case 'App & Web Development':
        return <AppWebDevelopmentSkills type={type} />;
      case 'Business & Startups':
        return <BusinessStartupSkills type={type} />;
      case 'Digital Marketing':
        return <MarketingSkills type={type} />;
      case 'Music':
        return <MusicAudioSkills type={type} />;
      case 'Video & Animation':
        return <VideoAnimationSkills type={type} />;
      case 'AI':
        return <AISkills type={type} />;
      default:
        return <DefaultSkills type={type} />;
    }
  };

  render() {
    const {
      user,
      authError,
      // children,
      route: { routes },
      count,
      loadedCount,
      location: { pathname, query },
      oldCount,
      loadedOldCount,
      unreadMessages,
      pendingRatings,
      isAsyncDataLoaded,
    } = this.props;

    if (isAsyncDataLoaded && authError && authError.status_code === 401) {
      if (typeof window !== 'undefined') {
        // Prevent infinite redirect loop by checking if we're already on signin
        if (window.location.pathname !== '/signin') {
          window.location.href = '/signin';
          return null;
        }
      }
    }

    const header = (
      <Fragment>
        <MainHeader
          user={user}
          count={count}
          loadedCount={loadedCount}
          loadedOldCount={loadedOldCount}
          oldCount={oldCount}
          unreadMessages={unreadMessages}
          isProject={this.isProject()}
          isJobs={this.isJobs()}
        />
        <Banner />
      </Fragment>
    );

    const app = (
      <Fragment>
        <div className={styles.app}>
          <Helmet
            {...config.app.head}
            link={[{ rel: 'icon', type: 'image/png', href: favicon }]}
          />
          {this.state.showPricingBanner && (
            <PricingPromotionBanner
              message={this.state.pricingBannerMessage}
              color={this.state.pricingBannerColor}
              link={this.state.pricingBannerLink}
              onClose={this.hidePricingBanner}
            />
          )}
          {header}
          {user && <CelloReferralBoot />}
          {!user?.pro && (this.isProject() || this.isJobs()) && (
            <StickyNavBar
              user={user}
              onProjectPage={this.isProject()}
              onJobsPage={this.isJobs()}
            />
          )}

          <LoadingBar color="#2cae76" ref={this.loadingRef} />
          <noscript>
            <div style={{ backgroundColor: '#d9534f', color: '#fff' }}>
              <div className="container text-center p">
                <strong>
                  <SvgIcon icon="alert_circle" /> Looks like you have JavaScript
                  disabled. For the full Twine experience, you will need to
                  re-enable it.
                </strong>
              </div>
            </div>
          </noscript>
          {renderRoutes(routes)}
          {pathname.indexOf('/messages') === -1 &&
          pathname.indexOf('/ats') === -1 ? (
            /(post|browse)/.test(pathname) ? (
              <SmallFooter />
            ) : (
              <DynamicFooter
                type={
                  /(jobs|projects)/.test(pathname) ? 'freelancer' : 'client'
                }
                getSkillsSection={this.getFooterSkillsSection}
                inverse={pathname.indexOf('/companies') > -1}
              />
            )
          ) : (
            <noscript />
          )}
          {pendingRatings.length > 0 ? (
            <RatingModal
              pitch={pendingRatings[0].message}
              user={pendingRatings[0].message.sender}
              onRated={this.handleRating}
            />
          ) : null}
          <Alert
            stack={{ limit: 3 }}
            onClose={() => {
              this.props.resetErrorMessage();
              this.props.resetSuccessMessage();
            }}
          />
          <AlertHandler
            error={this.props.error}
            successMessage={this.props.successMessage}
            user={user}
          />
          <div
            className="fade"
            id="darken-background"
            style={{
              position: 'fixed',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: '#000',
              opacity: 0,
              display: 'none',
            }}
          />
        </div>
      </Fragment>
    );

    // const withInlineDevtool = (
    //   <div style={{ display: 'flex' }}>
    //     <div style={{ display: 'flex', flex: '0.7' }}>{app}</div>
    //     <div style={{ display: 'flex', flex: '0.3' }}>
    //       <DevTools />
    //     </div>
    //   </div>
    // );
    // return __DEVELOPMENT__ ? withInlineDevtool : app;
    return app;
  }
}

export default App;
